import axios from 'axios'
import { Message } from 'element-ui'
import { getCookie, delCookie, setCookie } from 'common/js/mUtils'
import router from 'src/router/index.js'
/* http request 拦截器 request拦截器 是在向服务器发送请求 的过程中进行授权的每一次请求都会执行 */
axios.interceptors.request.use(
  config => {
    // 判断是否存在token 如果存在的话则每个http。header 都加上 token
    let token = getCookie('u_uuid_token')
    if (token) {
      config.headers.Authorization = `token ${token}`
    }
    return config
  },
  err => {
    Message.error({message: '请求超时!'})
    return Promise.resolve(err)
  })
// http response 拦截器
axios.interceptors.response.use(data => {
  let token = getCookie('u_uuid_token')
  if (token) {
    let tokenTime = Number(getCookie('u_uuid_time'))
    let newTime = new Date().getTime()
    if (newTime - tokenTime >= 10 * 60 * 1000 && newTime - tokenTime <= 15 * 60 * 1000) { // 判断存储的时间差
      postRequest('/return_token.php', {}).then(res => {
        console.log(res)
        setCookie('u_uuid_time', newTime)
        setCookie('u_uuid_token', res.data.token)
      })
    }
    if (newTime - tokenTime >= 15 * 60 * 1000) {
      delCookie('u_uuid_token')
      delCookie('u_uuid_time')
      delCookie('u_uuid_user_id')
    }
  }
  return data
},
err => {
  if (err.response) {
    switch (err.response.status) {
      case 401:
        // 返回401 清除token信息并跳转到登录页面
        delCookie('u_uuid_token')
        delCookie('u_uuid_time')
        delCookie('u_uuid_user_id')
        router.replace({
          path: '/login'
        })
        break
      case 504 || 404:
        Message.error({ message: '服务器被吃了⊙﹏⊙∥' })
        break
      case 403:
        Message.error({ message: '权限不足,请联系管理员!' })
        break
      case 505:
        Message.error({ message: '505错误!' })
        break
      default:
        Message.error({ message: '未知错误!' })
    }
  }
  return Promise.reject(err)
})
const base = process.env.API_ROOT

/* export const postRequest = (url, params) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  })
} */

export const postRequest = (url, params) => {
  return axios.post(`${base}${url}`, params)
}
export const uploadFileRequest = (url, params) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
export const putRequest = (url, params) => {
  return axios({
    method: 'put',
    url: `${base}${url}`,
    data: params,
    transformRequest: [
      function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }
    ],
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
export const deleteRequest = (url) => {
  return axios({
    method: 'delete',
    url: `${base}${url}` })
}
export const getRequest = (url) => { return axios({ method: 'get', url: `${base}${url}` }) }
/* 封装下载的函数 */
export const downloadRequest = (url, params) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    responseType: 'blob',
    headers: { 'Content-Type': 'application/json' }
  })
}



// WEBPACK FOOTER //
// ./src/common/js/http.js